import { useModal } from "@ebay/nice-modal-react";
import { useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { workflowsApi } from "@/react/api";
import type { TemplatesList } from "@/react/components/SettingsApp/Workflows/generated/WorkflowsApi.types";
import { Icon } from "@/react/components/shared/Icon";
import { ActionButton } from "@/react/components/shared/ModalsV2/MomentumModal/ActionButton";
import { ShareNotice } from "@/react/components/shared/ModalsV2/MomentumModal/ShareNotice";
import { workflowsSettingsPaths } from "@/react/helpers/urlHelpers/workflowsSettingsPaths";
import { ModalManager } from "@circle-react/components/Layout/ModalManagerProvider";
import { MomentumModal } from "@circle-react-shared/ModalsV2/MomentumModal";

export const WorkflowsMomentumModal = ModalManager.create(
  ({ templateKey }: { templateKey: string }) => {
    const modal = useModal();
    const history = useHistory();
    const { data, isLoading } = useQuery<TemplatesList>(
      ["workflow-templates", "ai_workflows"],
      () =>
        workflowsApi.templates({
          params: {
            category: "ai_workflows",
            v2_2_enabled: true,
          },
        }),
    );

    return (
      <MomentumModal
        isOpen={modal.visible}
        onClose={modal.hide}
        title={t(`workflows_v2.momentum_modal.${templateKey}.title`)}
        description={t(
          `workflows_v2.momentum_modal.${templateKey}.description`,
        )}
        isLoading={isLoading}
        data-testid="reported-post-momentum-modal"
      >
        <ShareNotice
          title={t(`workflows_v2.momentum_modal.${templateKey}.notice.title`)}
          description={t(
            `workflows_v2.momentum_modal.${templateKey}.notice.description`,
          )}
        >
          <ActionButton
            iconEl={<Icon type="20-zap" size={20} />}
            onClick={() => {
              const workflowId = data?.records?.find(
                template => template?.key === templateKey,
              )?.id;
              if (workflowId) {
                history.push(workflowsSettingsPaths.preview({ workflowId }));
              } else {
                history.push(workflowsSettingsPaths.new());
              }
              void modal.hide();
            }}
            disabled={isLoading}
            data-testid="create-moderation-workflow-button"
          >
            {t(`workflows_v2.momentum_modal.${templateKey}.notice.button`)}
          </ActionButton>
        </ShareNotice>
      </MomentumModal>
    );
  },
);
